import { NextRouter } from "next/router";
import {
  IGuidedHighlightingLevel,
  IGuidedHighlightingQuestion,
} from "@/view/utils/useGuidedHighlightingStudent/types";

export const GUIDED_HIGHLIGHTING_ACTIVITY_PANEL = "guided_highlighting_quiz";

export const toggleGuidedHighlightingActivityPanel = (
  router: NextRouter,
  forcedValue?: boolean,
  goBack?: boolean,
): void => {
  const pathname = router.pathname;
  const { activityPanel, ...query } = router.query;
  const newQuery = { ...query };

  if (forcedValue || !activityPanel) {
    newQuery["activityPanel"] = GUIDED_HIGHLIGHTING_ACTIVITY_PANEL;
  }

  if (goBack) {
    delete newQuery["activityPanel"];
  }

  void router.replace({ pathname, query: newQuery }, undefined, {
    shallow: true,
  });
};

export const handleGuidedHighlightingActiveQuestion = (
  guidedHighlightingData: IGuidedHighlightingLevel | undefined,
  handleActiveQuestion: (
    question: IGuidedHighlightingQuestion | undefined,
  ) => void,
) => {
  if (guidedHighlightingData?.questions) {
    const notAnsweredQuestions = guidedHighlightingData.questions.filter(
      (question) => (question?.attempt || 1) < 2 && !question.isCorrect,
    );
    handleActiveQuestion(notAnsweredQuestions[0]);
  }
};
